import { Component } from '@angular/core';
import { PlatformIdmService } from '@platform-idm/sdk-angular';
import { VirtualKeyboardService } from '../shared/VirtualKeyboardService';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrl: './login.component.scss',
    standalone: false
})
export class LoginComponent {
  constructor(private auth: PlatformIdmService) {

    this.auth.authentication.login();
  }

}
